import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DebrisTypeEquipement } from 'app/models/debrisTypeEquipement.model';
import { DebrisTypeEquipementService } from 'app/services/debris-type-equipement.service';

@Component({
  selector: 'app-modal-form-debris-type-equipement',
  templateUrl: './modal-form-debris-type-equipement.component.html',
  styleUrls: ['./modal-form-debris-type-equipement.component.scss']
})
export class ModalFormDebrisTypeEquipementComponent implements OnInit {
  success: boolean = false;
  error: boolean = false;

  debrisTypeEquipementForm: FormGroup;
  constructor(private debrisTypeEquipementService: DebrisTypeEquipementService, public dialogRef: MatDialogRef<ModalFormDebrisTypeEquipementComponent>) { }

  ngOnInit(): void {
    this.debrisTypeEquipementForm = new FormGroup({
      type: new FormControl(null, [Validators.required]),
    });
  }

  onFormSubmit() {
    this.error = false;
    this.success = false;
    this.debrisTypeEquipementForm.markAllAsTouched();

    if (this.debrisTypeEquipementForm.valid) {
      const debrisTypeEquipement = new DebrisTypeEquipement(this.debrisTypeEquipementForm.value);
      this.debrisTypeEquipementService.store(debrisTypeEquipement).subscribe(
        (response) => {
          this.success = true;
          this.dialogRef.close(response);
        }, (error) => { this.error = true; this.showErrors(error); }
      );
    }
  }

  showErrors(error: any) {
    //Gestion des erreurs laravel
    if (error instanceof HttpErrorResponse) {
      for (const key in error.error.errors) {
        //Todo
      }
    }
    else {
      error.forEach((element) => {
        //this.toastr.error(element);
      });
    }
  }
}
